import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cargar, seguimiento } from "../carga";


export const fetchCompras = createAsyncThunk(
  "Compras/fetchCompras",
  async () => {
    const compras = await cargar('compras');
    // Solo necesita los títulos: la vista resumida evita descargar todas las obras completas.
    const ObrasList = await cargar('obras?vista=resumen');

    return compras.map(compra => {
      const obraSeleccionada = ObrasList?.find(obra => obra._id === compra.idObra);
      return {
        ...compra,
        tituloObra: obraSeleccionada ? obraSeleccionada.titulo : 'Desconocido'
      }
    });
  }
);

export const fetchCompra = createAsyncThunk(
  "Compras/fetchCompra",
  async (id, thunkAPI) => {
    return await cargar(`compras/${id}`);
  }
);


export const ComprasSlice = createSlice({
  name: "compras",
  initialState: {
    compras: [],
    loading: false,
    error: null,
    compra: {},
  },
  reducers: {},
  extraReducers: builder => {
    seguimiento(builder, fetchCompras, 'compras');
    seguimiento(builder, fetchCompra, 'compra');
  },
});

export const selector = (state) => state.compras;

export default ComprasSlice.reducer;
